module.exports = __webpack_public_path__ + "static/seal-dark-green-1192406f183c4bbf35baa4cee414940f.svg";